import { gql } from '@apollo/client';

export const DELETE_CHECKOUT_REASON_MUTATION = gql`
  mutation DeleteCheckOutReason($id: Int!) {
    mcp {
      deleteCheckOutReason(id: $id) {
        success
        message {
          code
          message
        }
        content
      }
    }
  }
`;
